import images from "./images";

const projects = [
    {
        id: 1,
        image: images.project1,
        title: "Quran Studies",
        details: {
            date: "Jan 15, 2024",
            client: "Community Members",
            category: "Faith Education",
            duration: "Ongoing",
            location: "Main Prayer Hall & Online",
            cost: "Free of charge",
            projectLead: "Imam Abdullah"
        },
        paragraphs: [
            "Our Quran Studies program offers a structured and spiritually enriching approach to understanding the Holy Quran. It is designed for individuals of all ages and levels, from beginners learning the Arabic script to advanced students studying Tafsir and deeper meanings.",
            "Led by qualified scholars, the program combines recitation, memorization, and comprehension, ensuring that participants not only read the Quran fluently but also understand its message and apply it in daily life."
        ],
        gallery: [
            images.project1Gallery1,
            images.project1Gallery2,
            images.project1Gallery3,
            images.project1Gallery4,
            images.project1Gallery5,
            images.project1Gallery6
        ],
        objectives: [
            "Enhance understanding of the Quran and its teachings",
            "Develop proper Tajweed and recitation skills",
            "Encourage memorization for spiritual growth",
            "Promote implementation of Quranic guidance in daily life"
        ],
        impacts: [
            "Accommodating different learning paces and skill levels",
            "Ensuring consistent attendance and participation",
            "Providing both in-person and online class options",
            "Creating a supportive and inclusive learning environment"
        ],
        progress: [
            "Weekly classes for all age groups",
            "Special sessions on Tafsir and thematic studies",
            "Regular progress assessments for students",
            "Community events and Quran recitation competitions"
        ]
    },
    {
        id: 2,
        image: images.project2,
        title: "Youth Activities",
        details: {
            date: "Feb 10, 2024",
            client: "Youth Members",
            category: "Community Events",
            duration: "Ongoing",
            location: "Islamic Center & Outdoor Venues",
            cost: "Free / Minimal fee for special trips",
            projectLead: "Sister Aisha Khan"
        },
        paragraphs: [
            "Our Youth Activities program is designed to provide a safe, inspiring, and engaging space for young members of our community. The aim is to foster Islamic values, leadership qualities, and a strong sense of belonging through a variety of interactive sessions and events.",
            "Activities include educational workshops, sports tournaments, volunteering opportunities, Islamic study circles, and outdoor adventures — all guided by mentors who serve as positive role models for our youth."
        ],
        gallery: [
            images.project2Gallery1,
            images.project2Gallery2,
            images.project2Gallery3,
            images.project2Gallery4,
            images.project2Gallery5,
            images.project2Gallery6
        ],
        objectives: [
            "Engage youth in productive and faith-based activities",
            "Promote teamwork, leadership, and responsibility",
            "Strengthen Islamic identity and moral values",
            "Encourage community service and volunteerism"
        ],
        impacts: [
            "Addressing diverse interests within the youth group",
            "Balancing educational and recreational activities",
            "Maintaining consistent participation and enthusiasm",
            "Providing proper supervision and mentorship"
        ],
        progress: [
            "Weekly youth discussion circles and workshops",
            "Monthly sports and recreational events",
            "Annual youth leadership retreat",
            "Active volunteer teams for community projects"
        ]
    },
    {
        id: 3,
        image: images.project3,
        title: "Arabic Classes",
        details: {
            date: "Mar 05, 2024",
            client: "Community Members",
            category: "Faith Education",
            duration: "Weekly Sessions",
            location: "Islamic Center Classrooms",
            cost: "Free / Nominal Registration Fee",
            projectLead: "Brother Ahmed Hassan"
        },
        paragraphs: [
            "Our Arabic Classes program offers structured lessons for all age groups and skill levels, enabling students to learn the language of the Qur'an and strengthen their connection with Islamic texts. Classes are interactive and tailored to suit beginners, intermediate learners, and advanced students.",
            "The curriculum covers reading, writing, speaking, and comprehension, while also focusing on correct pronunciation (Tajweed) for Qur'anic recitation. Qualified instructors ensure an engaging and supportive learning environment."
        ],
        gallery: [
            images.project3Gallery1,
            images.project3Gallery2,
            images.project3Gallery3,
            images.project3Gallery4,
            images.project3Gallery5,
            images.project3Gallery6
        ],
        objectives: [
            "Teach Arabic language skills for everyday and Islamic use",
            "Enable accurate Qur’anic reading and understanding",
            "Build confidence in speaking and comprehension",
            "Promote cultural appreciation and heritage"
        ],
        impacts: [
            "Adapting lessons for different learning speeds",
            "Ensuring regular attendance and commitment",
            "Balancing grammar, vocabulary, and practical usage",
            "Providing engaging learning materials"
        ],
        progress: [
            "Multiple class levels from beginner to advanced",
            "Weekly vocabulary and grammar exercises",
            "Interactive group activities and speaking practice",
            "End-of-term assessments and certificates"
        ]
    },
    {
        id: 4,
        image: images.project4,
        title: "Food Drive",
        details: {
            date: "Apr 20, 2024",
            client: "Local Families in Need",
            category: "Charity Support",
            duration: "Monthly Initiative",
            location: "Islamic Center & Distribution Points",
            cost: "Funded by Donations",
            projectLead: "Sister Fatima Khan"
        },
        paragraphs: [
            "Our monthly Food Drive provides essential groceries and hot meals to underprivileged families within our community. The initiative ensures that no family goes hungry, especially during challenging times or special occasions such as Ramadan and Eid.",
            "Through the generosity of donors and the dedication of volunteers, we are able to collect, pack, and distribute food parcels that meet the dietary and cultural needs of recipients."
        ],
        gallery: [
            images.project4Gallery1,
            images.project4Gallery2,
            images.project4Gallery3,
            images.project4Gallery4,
            images.project4Gallery5,
            images.project4Gallery6
        ],
        objectives: [
            "Support low-income families with nutritious food",
            "Promote the Islamic value of charity (Sadaqah)",
            "Encourage community involvement and volunteerism",
            "Foster compassion and unity among members"
        ],
        impacts: [
            "Coordinating logistics for food collection and delivery",
            "Meeting diverse dietary requirements",
            "Managing food storage and safety",
            "Ensuring consistent volunteer participation"
        ],
        progress: [
            "Monthly distribution to over 200 families",
            "Partnerships with local businesses and donors",
            "Volunteer training for packing and distribution",
            "Tracking and reporting on community impact"
        ]
    },
    {
        id: 5,
        image: images.project5,
        title: "Iftar Gathering",
        details: {
            date: "Mar 25, 2024",
            client: "Community Members & Guests",
            category: "Community Events",
            duration: "Throughout Ramadan",
            location: "Islamic Center Main Hall",
            cost: "Funded by Donations & Sponsors",
            projectLead: "Brother Ahmed Raza"
        },
        paragraphs: [
            "Our annual Iftar Gatherings bring together community members, families, and guests to break their fast in a warm, welcoming environment. This initiative fosters unity, strengthens bonds, and allows everyone to share in the blessings of Ramadan.",
            "With delicious meals, spiritual reminders, and opportunities for charitable giving, the Iftar Gatherings serve both as a community event and a means of fulfilling the Sunnah of feeding those who fast."
        ],
        gallery: [
            images.project5Gallery1,
            images.project5Gallery2,
            images.project5Gallery3,
            images.project5Gallery4,
            images.project5Gallery5,
            images.project5Gallery6
        ],
        objectives: [
            "Provide a welcoming space for community members to break their fast",
            "Promote unity and togetherness during Ramadan",
            "Encourage charitable contributions and volunteer service",
            "Offer spiritual reminders and Islamic lectures"
        ],
        impacts: [
            "Coordinating meal preparation and serving",
            "Accommodating large numbers of attendees",
            "Ensuring a respectful and organized environment",
            "Managing volunteer teams effectively"
        ],
        progress: [
            "Daily gatherings attended by over 150 people",
            "Partnerships with local restaurants and sponsors",
            "Volunteer-led serving and cleanup teams",
            "Positive feedback and increased participation annually"
        ]
    },
    {
        id: 6,
        image: images.project6,
        title: "Medical Aid",
        details: {
            date: "Apr 10, 2024",
            client: "Needy Families & Individuals",
            category: "Charity Support",
            duration: "Ongoing",
            location: "Islamic Center & Partner Clinics",
            cost: "Funded by Donations & Grants",
            projectLead: "Sister Fatima Khan"
        },
        paragraphs: [
            "Our Medical Aid program provides essential healthcare support to community members in need, ensuring access to treatments, check-ups, and necessary medications regardless of financial situation.",
            "Partnering with local clinics and volunteer healthcare professionals, we aim to improve the health and well-being of our community by offering compassionate and accessible medical care."
        ],
        gallery: [
            images.project6Gallery1,
            images.project6Gallery2,
            images.project6Gallery3,
            images.project6Gallery4,
            images.project6Gallery5,
            images.project6Gallery6
        ],
        objectives: [
            "Offer free or subsidized medical services",
            "Provide access to essential medications",
            "Raise health awareness through workshops",
            "Support long-term health and wellness"
        ],
        impacts: [
            "Managing high demand for services",
            "Coordinating with multiple healthcare providers",
            "Securing consistent funding for treatments",
            "Ensuring privacy and dignity for all patients"
        ],
        progress: [
            "Over 500 patients assisted this year",
            "Regular monthly health camps",
            "Strong partnerships with medical professionals",
            "Positive improvement in community health indicators"
        ]
    }

];

export default projects;